/**
 * Query keys de TanStack Query para el dominio tasks.
 * Aislamos en un módulo propio para que cualquier hook (existente o nuevo)
 * importe las mismas llaves y las invalidaciones sean coherentes.
 */
import type * as tasksApi from '../api/tasks';

export const TASK_KEYS = {
  list: (filters?: tasksApi.ListTasksFilters) =>
    ['core', 'tasks', filters ?? {}] as const,
  byProspect: (prospectId: string) =>
    ['core', 'tasks', 'by-prospect', prospectId] as const,
  detail: (id: string) => ['core', 'tasks', id] as const,
  assignments: (taskId: string) =>
    ['core', 'task_assignments', taskId] as const,
  comments: (taskId: string) =>
    ['core', 'task_comments', taskId] as const,
  activity: (taskId: string) =>
    ['core', 'task_activity', taskId] as const,
  myDue: ['core', 'v_my_due_tasks'] as const,
  shares: (taskId: string) =>
    ['core', 'personal_task_shares', taskId] as const,
};
